/** Keeps streaming metrics distinct from HTTP data until the report supports session telemetry (ENG-6486). */
export function StreamingTranscriptionCard() {
  return (
    <article
      className="endpoint-card streaming-card"
      aria-label="Streaming transcription"
    >
      <div className="endpoint-card-title streaming-card-title">
        <span>
          Streaming transcription<small>WebSocket · transcription stream</small>
        </span>
      </div>
      <div className="endpoint-card-metrics streaming-summary">
        {[
          "Sessions started",
          "Streaming hours",
          "P50 time to first transcript",
          "Session error rate",
        ].map((label) => (
          <div key={label}>
            <strong>
              <span aria-hidden="true">—</span>
              <span className="sr-only">Unavailable</span>
            </strong>
            <small>{label}</small>
          </div>
        ))}
      </div>
      <div className="endpoint-loading streaming-unavailable">
        Streaming metrics are not yet available.
      </div>
    </article>
  );
}
